export default "__VITE_ASSET__e42b4d3c__"